import React from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";
import { Button } from "react-native-paper";

import CustomIcon from "../CustomIcon";
import { BUTTON_COLORS } from "./buttonColors";

export { BUTTON_COLORS };

interface AppButtonProps {
  label: string;
  onPress: () => void;
  variant?: "primary" | "secondary";
  icon?: string;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  testID?: string;
  accessibilityLabel?: string;
}

const AppButton: React.FC<AppButtonProps> = ({
  label,
  onPress,
  variant = "primary",
  icon,
  disabled,
  style,
  testID,
  accessibilityLabel,
}) => {
  const primary = variant === "primary";
  const textColor = primary
    ? BUTTON_COLORS.primaryText
    : BUTTON_COLORS.secondaryText;
  return (
    <Button
      mode={primary ? "contained" : "outlined"}
      onPress={onPress}
      disabled={disabled}
      testID={testID}
      accessibilityLabel={accessibilityLabel ?? label}
      buttonColor={primary ? BUTTON_COLORS.primaryBg : "transparent"}
      textColor={textColor}
      icon={
        icon
          ? ({ size }) => (
              <CustomIcon source={icon} size={size} color={textColor} />
            )
          : undefined
      }
      style={[
        styles.button,
        !primary && { borderColor: BUTTON_COLORS.secondaryBorder },
        style,
      ]}
      contentStyle={styles.content}
      labelStyle={styles.label}
    >
      {label}
    </Button>
  );
};

const styles = StyleSheet.create({
  button: {
    borderRadius: 12,
  },
  content: {
    height: 46,
  },
  label: {
    fontSize: 15,
    fontWeight: "600",
    letterSpacing: 0.2,
  },
});

export default AppButton;
